import { createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "o-box-content" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = { class: "c-find-assureur" }
const _hoisted_4 = {
  key: 0,
  class: "c-find-assureur__content"
}
const _hoisted_5 = { class: "c-find-assureur__row" }
const _hoisted_6 = { class: "c-find-assureur__label" }
const _hoisted_7 = { class: "c-find-assureur__value" }
const _hoisted_8 = ["href"]
const _hoisted_9 = {
  key: 1,
  class: "c-find-assureur__button"
}
const _hoisted_10 = ["href"]
const _hoisted_11 = { class: "o-button__text" }
const _hoisted_12 = { class: "o-button__text__elm" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_v_select = _resolveComponent("v-select")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "o-box__subtitle o-subtitle c-find-assureur__title",
      innerHTML: $options.t('Contactez directement <br>votre assureur')
    }, null, 8 /* PROPS */, _hoisted_2),
    _createElementVNode("div", _hoisted_3, [
      _createCommentVNode(" <div class=\"c-find-assureur__input\">\n                <svg class=\"o-ico c-find-assureur__ico -left\" aria-hidden=\"true\" role=\"img\">\n                    <use xlink:href=\"/assets/img/sprite.svg#search\"></use>\n                </svg>\n                <input type=\"text\" class=\"o-input c-find-assureur__input\" placeholder=\"Chercher un assureur\">\n                <svg class=\"o-ico c-find-assureur__ico -right\" aria-hidden=\"true\" role=\"img\">\n\t\t\t\t\t<use xlink:href=\"/assets/img/sprite.svg#arrow-down-alt\"></use>\n\t\t\t    </svg>\n            </div> "),
      _createVNode(_component_v_select, {
        class: "c-find-assureur__input",
        modelValue: $data.selectedAssureur,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($data.selectedAssureur) = $event)),
        options: $options.assureursOptions,
        placeholder: "Trouver mon assureur..."
      }, {
        "no-options": _withCtx(({ search, searching }) => [
          searching
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode(_toDisplayString($options.t('Aucun résultat pour')) + " ", 1 /* TEXT */),
                _createElementVNode("strong", null, _toDisplayString(search), 1 /* TEXT */)
              ], 64 /* STABLE_FRAGMENT */))
            : _createCommentVNode("v-if", true)
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["modelValue", "options"]),
      ($data.selectedAssureur)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            ($data.selectedAssureur.assureur.tel)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, _toDisplayString($options.t('Sans-frais')), 1 /* TEXT */),
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("a", {
                        href: $data.selectedAssureur.assureur.tel
                      }, _toDisplayString($options.formatPhone($data.selectedAssureur.assureur.tel)), 9 /* TEXT, PROPS */, _hoisted_8)
                    ])
                  ])
                ]))
              : _createCommentVNode("v-if", true),
            ($data.selectedAssureur.assureur.url)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _createElementVNode("a", {
                    href: $data.selectedAssureur.assureur.url,
                    class: "o-button -button-block-center -button-text -button-black",
                    target: "_blank",
                    rel: ""
                  }, [
                    _createElementVNode("span", _hoisted_11, [
                      _createElementVNode("span", _hoisted_12, _toDisplayString($options.t('Accéder au site Web')), 1 /* TEXT */)
                    ])
                  ], 8 /* PROPS */, _hoisted_10)
                ]))
              : _createCommentVNode("v-if", true)
          ], 64 /* STABLE_FRAGMENT */))
        : _createCommentVNode("v-if", true)
    ])
  ]))
}